import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";

function DocumentosAdmissao({
  valuesHook,
  downloadDocumento,
  dadosContratuaisValues,
  editavel,
  excluirDocumento,
  uploadDocumento,
  tabHook,
  salvaColaborador,
  togSolicitarAdmissaoModal,
  retornar,
}) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabHook;

  function handleChangeFile(e) {
    const dataArquivo = e.target.getAttribute("data-arquivo");
    uploadDocumento(dataArquivo, e.target.files[0]);
  }

  return (
    <>
      <div className="row align-items-center">
        <div className="col-md-6 mb-3">
          <label className="form-label requiredInput">
            CNH (caso não tenha, favor adicionar RG)
          </label>
        </div>
        <div className="col-md-6 mb-3">
          {values?.cnh_rg ? (
            <>
              <CommonButton
                color="info"
                onClick={() => {
                  downloadDocumento(
                    values?.cnh_rg?.caminho.split(".")[0],
                    values?.cnh_rg?.caminho.split(".")[1]
                  );
                }}
                style={{ marginRight: ".25rem" }}
              >
                <i className="mdi mdi-cloud-download d-block font-size-18"></i>
              </CommonButton>
              {editavel && (
                <CommonButton
                  color="danger"
                  onClick={() => {
                    excluirDocumento(values?.cnh_rg?.caminho);
                  }}
                >
                  <i className="mdi mdi-trash-can d-block font-size-18"></i>
                </CommonButton>
              )}
            </>
          ) : (
            <CommonInputFile
              label="Selecione o arquivo"
              accept="application/pdf"
              id="cnh_rg_novo"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              required
              data-arquivo="1"
            />
          )}
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-md-6 mb-3">
          <label className="form-label requiredInput">Título de eleitor</label>
        </div>
        <div className="col-md-6 mb-3">
          {values?.titulo_ir ? (
            <>
              <CommonButton
                color="info"
                onClick={() => {
                  downloadDocumento(
                    values?.titulo_ir?.caminho.split(".")[0],
                    values?.titulo_ir?.caminho.split(".")[1]
                  );
                }}
                style={{ marginRight: ".25rem" }}
              >
                <i className="mdi mdi-cloud-download d-block font-size-18"></i>
              </CommonButton>
              {editavel && (
                <CommonButton
                  color="danger"
                  onClick={() => {
                    excluirDocumento(values?.titulo_ir?.caminho);
                  }}
                >
                  <i className="mdi mdi-trash-can d-block font-size-18"></i>
                </CommonButton>
              )}
            </>
          ) : (
            <CommonInputFile
              label="Selecione o arquivo"
              accept="application/pdf"
              id="titulo_ir_novo"
              onChange={(e) => handleChangeFile(e, values, setValues)}
              required
              data-arquivo="2"
            />
          )}
        </div>
      </div>
      {dadosContratuaisValues?.categoria === 1 ||
      dadosContratuaisValues?.categoria === "1" ? (
        <div className="row align-items-center">
          <div className="col-md-6 mb-3">
            <label className="form-label requiredInput">
              Exame admissional
            </label>
          </div>
          <div className="col-md-6 mb-3">
            {values?.exame_admissional ? (
              <>
                <CommonButton
                  color="info"
                  onClick={() => {
                    downloadDocumento(
                      values?.exame_admissional?.caminho.split(".")[0],
                      values?.exame_admissional?.caminho.split(".")[1]
                    );
                  }}
                  style={{ marginRight: ".25rem" }}
                >
                  <i className="mdi mdi-cloud-download d-block font-size-18"></i>
                </CommonButton>
                {editavel && (
                  <CommonButton
                    color="danger"
                    onClick={() => {
                      excluirDocumento(values?.exame_admissional?.caminho);
                    }}
                  >
                    <i className="mdi mdi-trash-can d-block font-size-18"></i>
                  </CommonButton>
                )}
              </>
            ) : (
              <CommonInputFile
                label="Selecione o arquivo"
                accept="application/pdf"
                id="exame_admissional_novo"
                onChange={(e) => handleChangeFile(e, values, setValues)}
                required
                data-arquivo="3"
              />
            )}
          </div>
        </div>
      ) : null}
      {dadosContratuaisValues?.categoria === 2 ||
      dadosContratuaisValues?.categoria === "2" ? (
        <div className="row align-items-center">
          <div className="col-md-6 mb-3">
            <label className="form-label requiredInput">
              Contrato de estágio com a faculdade
            </label>
          </div>
          <div className="col-md-6 mb-3">
            {values?.contrato_faculdade ? (
              <>
                <CommonButton
                  color="info"
                  onClick={() => {
                    downloadDocumento(
                      values?.contrato_faculdade?.caminho.split(".")[0],
                      values?.contrato_faculdade?.caminho.split(".")[1]
                    );
                  }}
                  style={{ marginRight: ".25rem" }}
                >
                  <i className="mdi mdi-cloud-download d-block font-size-18"></i>
                </CommonButton>
                {editavel && (
                  <CommonButton
                    color="danger"
                    onClick={() => {
                      excluirDocumento(values?.contrato_faculdade?.caminho);
                    }}
                  >
                    <i className="mdi mdi-trash-can d-block font-size-18"></i>
                  </CommonButton>
                )}
              </>
            ) : (
              <CommonInputFile
                label="Selecione o arquivo"
                accept="application/pdf"
                id="contrato_faculdade_novo"
                onChange={(e) => handleChangeFile(e, values, setValues)}
                required
                data-arquivo="4"
              />
            )}
          </div>
        </div>
      ) : null}
      <div className="row mb-3 mx-0">
        <div className="d-flex justify-content-between flex-column flex-md-row align-items-center gap-1">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <div className="d-flex flex-column flex-md-row align-items-center gap-1">
            <CommonButton onClick={retornar} color="danger">
              Voltar
            </CommonButton>
            {editavel ? (
              <CommonButton onClick={salvaColaborador} color="success">
                {"Salvar rascunho"}
              </CommonButton>
            ) : null}
            {editavel && (
              <CommonButton onClick={togSolicitarAdmissaoModal} color="warning">
                Solicitar admissão
              </CommonButton>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

DocumentosAdmissao.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  dadosContratuaisValues: PropTypes.object.isRequired,
  editavel: PropTypes.bool.isRequired,
  excluirDocumento: PropTypes.func.isRequired,
  uploadDocumento: PropTypes.func.isRequired,
  tabHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  salvaColaborador: PropTypes.func.isRequired,
  togSolicitarAdmissaoModal: PropTypes.func.isRequired,
  retornar: PropTypes.func.isRequired,
};

export default DocumentosAdmissao;
